// Error Handler Utility
export class ErrorHandler {
  // Xử lý lỗi Firebase
  static handleFirebaseError(error, context = '') {
    console.error(`🔥 Firebase Error ${context}:`, error);
    
    // Phân loại lỗi Firebase
    switch (error.code) {
      case 'permission-denied':
        return 'Không có quyền truy cập. Vui lòng kiểm tra quyền của bạn.';
      
      case 'unavailable':
        return 'Dịch vụ tạm thời không khả dụng. Vui lòng thử lại sau.';
      
      case 'unauthenticated':
        return 'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.';
      
      case 'not-found':
        return 'Không tìm thấy dữ liệu.';
      
      case 'already-exists':
        return 'Dữ liệu đã tồn tại.';
      
      case 'invalid-argument':
        return 'Dữ liệu không hợp lệ.';
      
      case 'deadline-exceeded':
        return 'Yêu cầu hết thời gian chờ. Vui lòng thử lại.';
      
      case 'resource-exhausted':
        return 'Hệ thống quá tải. Vui lòng thử lại sau.';
      
      case 'failed-precondition':
        return 'Điều kiện tiên quyết không được thỏa mãn.';
      
      case 'aborted':
        return 'Yêu cầu đã bị hủy.';
      
      case 'out-of-range':
        return 'Giá trị nằm ngoài phạm vi cho phép.';
      
      case 'unimplemented':
        return 'Chức năng chưa được triển khai.';
      
      case 'internal':
        return 'Lỗi nội bộ hệ thống. Vui lòng thử lại.';
      
      case 'data-loss':
        return 'Dữ liệu bị mất. Vui lòng kiểm tra lại.';
      
      default:
        return `Lỗi không xác định: ${error.message}`;
    }
  }

  // Xử lý lỗi network
  static handleNetworkError(error, context = '') {
    console.error(`🌐 Network Error ${context}:`, error);
    
    if (!navigator.onLine) {
      return 'Không có kết nối internet. Vui lòng kiểm tra kết nối.';
    }
    
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      return 'Lỗi kết nối mạng. Vui lòng thử lại.';
    }
    
    return 'Lỗi kết nối. Vui lòng thử lại.';
  }

  // Xử lý lỗi validation
  static handleValidationError(error, context = '') {
    console.error(`✅ Validation Error ${context}:`, error);
    return error.message || 'Dữ liệu không hợp lệ.';
  }

  // Xử lý lỗi chung
  static handleError(error, context = '') {
    console.error(`❌ Error ${context}:`, error);
    
    // Firebase error
    if (error.code) {
      return this.handleFirebaseError(error, context);
    }
    
    // Network error
    if (error.name === 'TypeError' || error.message?.includes('fetch')) {
      return this.handleNetworkError(error, context);
    }
    
    // Validation error
    if (error.name === 'ValidationError') {
      return this.handleValidationError(error, context);
    }
    
    // Generic error
    return error.message || 'Đã xảy ra lỗi. Vui lòng thử lại.';
  }

  // Wrapper cho async functions
  static async safeAsync(asyncFn, context = '') {
    try {
      return await asyncFn();
    } catch (error) {
      const errorMessage = this.handleError(error, context);
      throw new Error(errorMessage);
    }
  }

  // Wrapper cho sync functions
  static safeSync(syncFn, context = '') {
    try {
      return syncFn();
    } catch (error) {
      const errorMessage = this.handleError(error, context);
      throw new Error(errorMessage);
    }
  }

  // Log error với thông tin chi tiết
  static logError(error, context = '', additionalInfo = {}) {
    const errorInfo = {
      message: error.message,
      stack: error.stack,
      context,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      url: window.location.href,
      ...additionalInfo
    };
    
    console.error('📊 Error Details:', errorInfo);
    
    // Có thể gửi lỗi lên server để tracking
    // this.reportError(errorInfo);
  }

  // Báo cáo lỗi lên server (tùy chọn)
  static async reportError(errorInfo) {
    try {
      // Implement error reporting service
      // await fetch('/api/errors', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify(errorInfo)
      // });
    } catch (reportError) {
      console.error('Failed to report error:', reportError);
    }
  }
}

// Export default
export default ErrorHandler;
